import { render, staticRenderFns } from "./StudentSelect.vue?vue&type=template&id=02f32a8e&scoped=true&"
import script from "./StudentSelect.vue?vue&type=script&lang=js&"
export * from "./StudentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f32a8e",
  null
  
)

export default component.exports